import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
import { xFindClosestIndex } from 'ml-spectra-processing';
import { get1DDataXY } from '../../data/data1d/Spectrum1D/get1DDataXY';
import { useMouseTracker } from '../EventsTrackers/MouseTracker';
import { useChartData } from '../context/ChartContext';
import { useScale } from '../context/ScaleContext';
import { SVGGroup } from '../elements/SVGGroup';
import { usePanelPreferences } from '../hooks/usePanelPreferences';
import { convertPathArrayToString } from '../utility/convertPathArrayToString';
const styles = {
    text: {
        fontSize: '12px',
        fill: 'black',
    },
    colorIndicator: {
        width: '10px',
        height: '2px',
    },
};
function YTracker({ datum }) {
    const { scaleX } = useScale();
    const position = useMouseTracker();
    if (!scaleX || !position) {
        return null;
    }
    const xIndex = xFindClosestIndex(datum.x, scaleX().invert(position.x));
    return (_jsx("text", { style: styles.text, alignmentBaseline: "middle", children: datum.y[xIndex] }));
}
function InnerSpectraLegends({ spectra, legendsFields, }) {
    return (_jsx("g", { className: "spectra-intensity-legend", children: spectra.map((spectrum, index) => (_jsxs("g", { transform: `translate(5,${20 * (index + 1)})`, children: [_jsx("rect", { style: {
                        ...styles.colorIndicator,
                        fill: spectrum.display.color,
                    } }), _jsx(SVGGroup, { space: 5, transform: "translate(12 0)", children: legendsFields.map((field) => {
                        const predefinedField = field;
                        switch (predefinedField?.name) {
                            case 'intensity':
                                return (_jsxs("g", { children: [_jsx(YTracker, { datum: get1DDataXY(spectrum) }), _jsx("rect", { width: "55", height: "1", fill: "transparent" })] }, "intensity"));
                            case 'name':
                                return (_jsx("text", { alignmentBaseline: "middle", style: styles.text, children: spectrum.info.name }, "name"));
                            default: {
                                const jpath = field.jpath;
                                const value = lodashGet(spectrum, jpath, '');
                                return (_jsx("text", { alignmentBaseline: "middle", style: styles.text, children: value }, convertPathArrayToString(jpath)));
                            }
                        }
                    }) })] }, spectrum.id))) }));
}
function SpectraLegends() {
    const { data, view: { spectra: { activeTab, showLegend }, }, xDomains, } = useChartData();
    const { legendsFields } = usePanelPreferences('multipleSpectraAnalysis', activeTab);
    if (!showLegend)
        return null;
    const spectra = data.filter((spectrum) => spectrum.display.isVisible &&
        xDomains[spectrum.id] &&
        spectrum.info.nucleus === activeTab);
    return (_jsx(InnerSpectraLegends, { spectra: spectra, legendsFields: legendsFields }));
}
export default SpectraLegends;
